import { Component, Input } from '@angular/core'
import { Privilege } from '@core/model/enums/privilege.enum'
import { ScopeElementsConfig } from '../models'
import { isPreferenceActive } from '@app/shared/components/ui-components/scope-ui-table/table-column-preferences.type'

@Component({ selector: 'scope-deliverables-row-header', templateUrl: './deliverables-row-header.component.html' })
export class DeliverablesRowHeaderComponent {
  @Input() level: number
  @Input() config: ScopeElementsConfig

  protected readonly Privilege = Privilege
  protected readonly isPreferenceActive = isPreferenceActive
}
